module.exports = __webpack_public_path__ + "img/c03d3a2.png";